export default "__VITE_ASSET__0773e140__"